<template>
  <div class="hotGoods" v-if="goodList.length">
    <div class="enjoy_title">
      <h3>猜你喜欢</h3>
    </div>
    <div class="good-list">
      <template v-for="item in goodList">
        <good-card size="200px" :good="item" :key="item.id"></good-card>
      </template>
    </div>
  </div>
</template>
<script>
import {commoditylist} from "@/api/xunyou";
import GoodCard from '@/components/good-card';
export default {
  data() {
    return {
      goodList: [],
    };
  },
  components: {
    GoodCard
  },
  created() {
    this.getGoodlist()
  },
  methods: {
    // 商品列表查询
    getGoodlist() {
      this.loading = true;
      commoditylist({
        pageNum: 1,
        pageSize: 10,
        cid: '' // 查全部
      }).then((res) => {
        console.log('假的热门商品：', res);
        this.loading = false;
        if (res.code === 0) {
          this.goodList = res.rows
        }
      }).catch((err) => {
        this.loading = false;
        this.$message.error("查询失败，请稍后再试！");
      });
    },
  },
};
</script>

<style scoped lang='less'>
.good-list{
  .product{
    margin: 0 5px 10px 5px;
  }
}
.hotGoods {
  margin: 40px 0;
}
</style>







// WEBPACK FOOTER //
// src/components/favoritGoods.vue